var _path, _rect, _rect2, _rect3, _circle, _circle2, _path2, _rect4, _rect5, _g, _rect6, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 164,
    viewBox: "0 0 228 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 77C64.5 66.2304 73.2304 57.5 84 57.5H163.5V156.5H64.5V77Z",
    stroke: "#0F214F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 109,
    width: 40,
    height: 6,
    fill: "#C9FEFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 120,
    width: 65,
    height: 6,
    fill: "#C9FEFE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 131,
    width: 20,
    height: 6,
    fill: "#C9FEFE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 23.5,
    r: 17.5,
    fill: "#77DDFB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 23,
    r: 22.5,
    stroke: "#0F214F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4165 16.417V19.1886H94.6404L85.4395 28.3896L87.6108 30.5609L96.8115 21.36V30.5837H99.5832V19.1886V16.417H85.4165Z",
    fill: "#0F214F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 73,
    width: 56,
    height: 6,
    fill: "#0F214F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2137_1109",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 31,
    width: 48,
    height: 48
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 31,
    width: 48,
    height: 48,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2137_1109)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 71,
    r: 23,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 71,
    r: 22.5,
    stroke: "#0F214F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.5,
    cy: 71.5,
    r: 17.5,
    fill: "#77DDFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.417 64.417V67.1886H117.64L108.439 76.3896L110.611 78.5609L119.812 69.36V78.5837H122.583V67.1886V64.417H108.417Z",
    fill: "#0F214F"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 156,
    width: 110,
    height: 8,
    fill: "#0F214F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M196 69C196 62.3726 201.373 57 208 57H216C222.627 57 228 62.3726 228 69V77C228 83.6274 222.627 89 216 89H196V69Z",
    fill: "#0F214F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217 70.5087L215.543 69L210.712 74.0028L208.457 71.6671L207 73.1758L210.712 77L217 70.5087Z",
    fill: "#0F214F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44 124C44 119.582 40.4183 116 36 116H20C15.5817 116 12 119.582 12 124V140C12 144.418 15.5817 148 20 148H44V124Z",
    fill: "#77DDFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 133.636L24.6363 137L23 135.364L26.3637 132L23 128.636L24.6363 127L28 130.364L31.3637 127L33 128.636L29.6363 132L33 135.364L31.3637 137L28 133.636Z",
    fill: "#0F214F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 76C23.5 71.8579 20.1421 68.5 16 68.5H8C3.85786 68.5 0.5 71.8579 0.5 76V84C0.5 88.1421 3.85786 91.5 8 91.5H23.5V76Z",
    stroke: "#0F214F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 86.3125C15.2101 86.3125 17.8125 83.7101 17.8125 80.5C17.8125 77.2899 15.2101 74.6875 12 74.6875C8.78986 74.6875 6.1875 77.2898 6.1875 80.5C6.1875 83.7101 8.78986 86.3125 12 86.3125ZM15.534 82.9733L9.52663 76.966C11.172 75.8092 13.5163 75.9175 15.0494 77.4506C16.5833 78.9845 16.69 81.329 15.534 82.9733ZM8.46597 78.0266C7.30996 79.6709 7.41666 82.0155 8.95058 83.5494C10.4837 85.0825 12.828 85.1907 14.4733 84.034L8.46597 78.0266Z",
    fill: "#0F214F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 121C184.5 116.858 187.858 113.5 192 113.5H200C204.142 113.5 207.5 116.858 207.5 121V129C207.5 133.142 204.142 136.5 200 136.5H184.5V121Z",
    stroke: "#0F214F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 124,
    width: 10,
    height: 3,
    fill: "#0F214F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtDeposit);
export default __webpack_public_path__ + "static/media/art-deposit.1604cc5d54985fb68286167904947586.svg";
export { ForwardRef as ReactComponent };